/**
 * 通用
 */
import * as ACTION from '../constants/types/commonTypes';
import * as $$BASE from './baseAction';
import { packageReq } from '../helpers/request';
import { packageObsoleteReq } from '../deconstructionCenter/obsoleteApi';

// 获取banner信息
export function getBanners(bannerId) {

	var payload = packageReq('BANNER_ALL', [bannerId], null, 'GET');

	return {
		type: ACTION.GET_BANNERS,
		payload
	}

}

// 获取动态配置信息，运行环境等
export function getWebContext(){

	// 需要获取的环境变量字段
	const fields = [
		// 'client_version', // 缓存版本号
		// 'customer_service_url', // 客服链接
		// 'app_download_url', // APP下载二维码地址
		// "agreement" //用户协议
	]

	var payload = packageReq('GET_WEB_SETTINGS', [_.join(fields)], null, 'GET');

	return {
		type: ACTION.GET_WEB_SETTINGS,
		payload
	}

}


// 获取公告列表
export function getBulletins(pageNo) {

	var payload = packageReq('BULLETIN_ALL', [pageNo], null, 'GET');

	return {
		type: ACTION.GET_BULLETINS,
		payload
	}

}

// 获取中奖名单
export function getWinners() {

	var payload = packageReq('WINNER_ALL', null, null, 'GET');

	return {
		type: ACTION.GET_WINNERS,
		payload
	}

}

// 获取验证码
export function getValidcode(){

	var payload = packageReq("GET_VALIDCODE", null, null, 'GET');

	return {
		type: ACTION.GET_VALIDCODE,
		payload
	}

}

// 获取公告详情
export function getBulletinDetail(bulletinId){

	var payload = packageReq("BULLETIN_DETAIL", [bulletinId], null, 'GET');

	return {
		type: ACTION.GET_BULLETIN_DETAIL,
		payload
	}

}

// 关闭右下角中奖提示
export function closeWinnerNotice(){
	return {
		type: ACTION.CLOSE_WINNER_NOTICE
	}
}

// 打开关闭验证码输入框
export function toggleVaildCode(status){
	return {
		type: ACTION.TOGGLE_VAILDCODE,
		status: status,
		relations: status ? [getValidcode()] : null
	}
}

// 登录页域名验证
export function verfiyDomain(url, validcode){

	const domain = url.split('http://')[1];
	var payload = packageReq("GET_CHECK_URLS", [domain, validcode], null, 'GET');

	return {
		type: ACTION.GET_CHECK_URLS,
		domain: domain,
		payload,
		ignoreError: true,
		_done_:[
			{
				action: markDomainStatus,
				takeParam: true
			}
		]
	}
}

//域名验证判断
export function markDomainStatus(data, payload){

	const { status, message } = data;

	// 验证码错误
	if (status === 20205) {
		return {
			type: 'HANDLE_DOMAIN_VAILDCODE_ERROR',
			relations: [
				getValidcode(),
				$$BASE.openAlert(message)
			]
		}
	}
	// 验证失败
	if (status === 33003) {
		return {
			type: ACTION.MARK_DOMAIN_STATUS,
			status: false,
			domain: payload.domain
		}
	}
	//成功
	if (status === 10000) {
		return {
			type: ACTION.MARK_DOMAIN_STATUS,
			status: true,
			domain: payload.domain
		}
	}
	return $$BASE.openAlert(message)

}

//登录页清除域名验证数据
export function clearDomainStatus(){
	return {type: ACTION.CLEAR_DOMAIN_STATUS}
}

// 获取测速域名
export function getSpeedDomains(){
	var payload = packageReq("GET_SPEEDTEST_URLS", null, null, 'GET');
	return {
		type: ACTION.GET_SPEED_DOMAINS,
		payload
	}
}


 /**
 * 获取站内信
 * @author ammo 2018-05-17
 * @param  {[type]} page [description]
 * @return {[type]}      [description]
 */
export function getMessages(page){

	var payload = packageReq('GET_MESSAGES', page.toString(), null, 'GET');
	return {
		type: ACTION.GET_MESSAGES,
		payload
	}

}


/**
 * 获取message详情
 * @author ammo 2018-05-17
 * @param  {[type]} messageId [description]
 * @return {[type]}           [description]
 */
export function getMessageDetail(messageId){

	var payload = packageReq('MESSAGES_ACTION', [messageId], null, 'GET', true);
	return {
		type: ACTION.GET_MESSAGES_DETAIL,
		payload
	}

}

/**
 * 删除站内信
 * @author ammo 2018-05-17
 * @param  {[type]} messageId [description]
 * @return {[type]}           [description]
 */
export function deleteMessageById(messageId){

	var payload = packageReq('MESSAGES_ACTION', [messageId], null, 'DELETE');
	return {
		type: ACTION.DELETE_MESSAGES,
		payload,
		extend: messageId,
		_done_:[
			{
				action: getMessages(1),
				takeParam: false
			}
		],
		_success_: [
			{
				action: $$BASE.openAlert('删除信息成功!'),
				takeParam: false
			}
		]
	}

}


/**
 * [deleteMultiMessage 批量删除]
 * @author ammo 2018-05-17
 * @param  {[array]} ids [description]
 * @return {[type]}      [description]
 */
export function deleteMultiMessage(ids){

	var dirtyPayload = packageObsoleteReq('DELETE_MULTI_MESSAGE', null, {checkboxes: ids}, 'POST');

	return {
		type: ACTION.DELETE_MULTI_MESSAGE,
		dirtyPayload
	}

}


/**
 * 删除所有站内信
 * @author ammo 2018-05-17
 * @return {[type]} [description]
 */
export function deleteAllMessage(){

	var dirtyPayload = packageObsoleteReq('DELETE_ALL_MESSAGE', null, null, 'GET');

	return {
		type: ACTION.DELETE_ALL_MESSAGE,
		dirtyPayload,
	}

}


/**
 * 获取收藏列表
 * @author ammo 2018-06-21
 * @param  {String} type  [description]
 * @param  {String} sort  [description]
 * @param  {String} limit [description]
 * @return {[type]}       [description]
 */
export function getFavoritesList(type='lottery', sort='created_at', limit='10'){

	var payload = packageReq('FAVORITES_LIST', [limit, type, sort], null, 'GET');

	return {
		type: ACTION.FAVORITES_LIST,
		payload,
		extend: type
	}

}


/**
 * 添加收藏
 * @author ammo 2018-06-21
 * @param  {String} type [description]
 * @return {[type]}      [description]
 */
export function createFavorites(type='lottery', request){

	var payload = packageReq('FAVORITES_CREATE', [type], request, 'POST');

	return {
		type: ACTION.FAVORITES_CREATE,
		payload,
		extend: request
	}
}


/**
 * 批量删除收藏
 * @author ammo 2018-06-21
 * @param  {[type]} request [description]
 * @return {[type]}         [description]
 */
export function deleteFavorites(request, type='lottery'){

	var payload = packageReq('FAVORITES_DELETE', null, request, 'DELETE');

	return {
		type: ACTION.FAVORITES_DELETE,
		payload,
		extend: request
	}

}
